import * as styles from "./KnobThumb.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useKnobContext } from "./Knob.context";
import type { KnobThumbProps } from "./Knob.types";

export function KnobThumb({ className }: KnobThumbProps): JSX.Element {
  const { percent, disabled, diameter, radius, thumbSize } = useKnobContext();
  const center = diameter / 2;
  const angle = percent * 2 * Math.PI - Math.PI / 2;
  const x = center + radius * Math.cos(angle);
  const y = center + radius * Math.sin(angle);

  const percentOf = (n: number) => `${(n / diameter) * 100}%`;

  return (
    <span
      data-slot="knob-thumb"
      data-disabled={disabled || undefined}
      className={clsx(styles.thumb, className)}
      style={{
        width: percentOf(thumbSize),
        height: percentOf(thumbSize),
        left: percentOf(x),
        top: percentOf(y),
        transform: "translate(-50%, -50%)",
      }}
    />
  );
}
